<template>
    <div id="pro-layout">
        <div id="pro-cmaj-form" class="preview" style="margin-left: 200px;" v-if="!this.$global.loading">
            <div class="pro-main-container">
                <div class="pt-5 pb-5 header w-100">
                    <div class="mx-auto col-11 d-flex justify-content-between">
                        <div>
                            <h4 style="color: gray">{{ provider.name }}</h4>
                            <h1 v-if="aspect !== null">Mes informations -
                                <span v-if="aspect === 'business'">Tourisme d'Affaires 💼</span>
                                <span v-else-if="aspect === 'winter'">Hiver ❄️</span>
                                <span v-else-if="aspect === 'summer'">Eté 🔆</span>
                            </h1>
                            <h1 v-else-if="formTittle === null || formTittle.value === null">Formulaire de validation de vos
                                informations</h1>
                            <h1 v-else>{{ formTittle.value }}</h1>
                        </div>
                        <div class="logo ml-3">
                            <v-img height="100px" max-width="300px" position="right" contain :src="logo.doc_url">
                            </v-img>
                        </div>
                    </div>
                </div>

                <div class="pro-main-container-bloc pt-5"
                     :style="'background-color:' + backGroundColor + ';font-family:' + fontFamily">
                    <div class="mx-auto col-11">
                        <form-container :form-title="formTittle"
                                        :logo="logo"
                                        :organism="organism"
                                        :txt-intro="txtIntro"
                                        :no-header="true"
                                        :referent="null"
                                        :loaded="loaded"
                                        :code="null"
                                        :cgu="cgu"
                                        :sit="false">
                        </form-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Covid from "../pro/CMAJ/tabulations/Covid"
import {mapGetters, mapMutations, mapState} from "vuex"
import General from "../pro/CMAJ/tabulations/General"
import Handicapped from "../pro/CMAJ/tabulations/Handicapped"
import Localisation from "../pro/CMAJ/tabulations/Localisation"
import Contacts from "../pro/CMAJ/tabulations/Contacts"
import Medias from "../pro/CMAJ/tabulations/Medias"
import RoomRenting from "../pro/CMAJ/tabulations/RoomRenting"
import Specific from "../pro/CMAJ/tabulations/Specific"
import OpeningHours from "../pro/CMAJ/tabulations/OpeningHours"
import PricePeriods from "../pro/CMAJ/tabulations/PricePeriods"
import Capacities from "../pro/CMAJ/tabulations/Capacities"
import Extra from "../pro/CMAJ/tabulations/Extra"
import ProCmajMenu from "../pro/CMAJ/CmajFormMenu.vue"
import Platform from "../pro/CMAJ/tabulations/Platform"
import ApidaeContacts from "../pro/CMAJ/tabulations/ApidaeContacts";
import PrivateDescriptifs from "../pro/CMAJ/tabulations/PrivateDescriptifs.vue"
import FormContainer from "../pro/CMAJ/FormContainer.vue"

export default {
    name: "Preview",
    components: {
        FormContainer,
        PrivateDescriptifs,
        ApidaeContacts,
        ProCmajMenu,
        Extra,
        Capacities,
        PricePeriods,
        OpeningHours,
        Specific,
        RoomRenting,
        Medias,
        Contacts,
        Localisation,
        General,
        Handicapped,
        Covid,
        Platform
    },
    data() {
        return {
            categoryCode: null,
            logo: {},
            cgu: null,
            organism: {},
            txtIntro: null,
            formTittle: null,
            tabulations: [],
            provider: {
                elements: [],
                contents: [],
                communications: [],
                medias: [],
                localisation: {
                    latitude: null,
                    longitude: null
                },
                opening_periods: [],
                price_periods: [],
                capacities: [],
                booking_links: [],
                boolean_elements: [],
                numeric_fields: [],
                date_fields: [],
                contacts: [],
                category: null,
                private_descriptions: []
            },
            loaded: false,
            aspect: null,
        }
    },
    methods: {
        ...mapMutations('webFormStyle', ['setFieldsColor', 'setTitlesColor', 'setPrimaryColor',
            'setBackGroundColor', 'setFontFamily']),
        ...mapMutations('web_form', [
            'setFields', 'setFamilyElements', 'setCategoryFamilies', 'setProvider', 'setCapacities',
            'setContact', 'generateTabulations', 'generateTabActiveRanges', 'setPreview', 'handleSpecificTabulation',
            'orderTabulations', 'setEditedTabulations', 'setSourcesLoaded',
        ]),
        ...mapMutations('forbiddenCriteria', ['setForbiddenCriteria']),
        getPreviewData() {
            this.$global.loading = true
            this.loaded = false

            this.$http.get('auth/webform/preview/' + this.categoryCode).then(res => {
                let config = res.body.data.config

                this.logo = config.logo
                this.organism = config.organism !== null ? config.organism.value : null
                this.cgu = config.cgu.doc_url
                this.txtIntro = this.previewTxtIntro
                this.formTittle = config.formTittle

                this.setContact({
                    first_name: null,
                    last_name: null,
                    email: null
                })

                this.setEditedTabulations(this.previewEditedTabulations)
                this.setFields(res.body.data.fields)
                this.setProvider(this.provider)
                this.setForbiddenCriteria(res.body.data.forbiddenCriteria)
                this.setContact(this.contact)
                this.setCategoryFamilies(res.body.data.families)
                this.setFamilyElements(res.body.data.referential)
                this.loadCustomCss(res.body.data.webFormStyle)

                let capacities = this.getFamilyByCode('Capacites')

                this.setCapacities(capacities)

                if (this.categoryFields[this.categoryCode] !== undefined && this.categoryFields[this.categoryCode].length) {
                    this.filterFields()
                }

                this.provider.category = this.categories.find(category => category.name = this.categoryCode)

                this.generateTabulations(false)
                this.handleSpecificTabulation()
                this.orderTabulations()

                setTimeout(() => {
                    this.generateTabActiveRanges()
                }, 1000)

                this.loaded = true

                this.$global.loading = false
            })
        },
        filterFields() {
            let currentFields = collect(this.fields)
            let filtered = collect()

            currentFields.items.forEach(currentField => {
                let exist = this.categoryFields[this.categoryCode].find(field => field.field_id === currentField.id)

                if (exist !== null && exist !== undefined) {
                    if (exist.new_title !== null && exist.new_title !== undefined) {
                        currentField.name = exist.new_title
                    } else {
                        currentField.name = exist.name
                    }

                    currentField.helpDescription = exist.help_description
                    currentField.required = exist.required

                    filtered.push(currentField)
                }
            })

            this.setFields(filtered.toArray())
        },
        generateTabActiveRanges() {
            this.tabulations.forEach(tab => {
                let element = document.getElementsByClassName(tab.anchor)

                if (element !== undefined && element.length > 0) {
                    element = element[0]

                    let offsetTop = element.offsetTop
                    let height = element.offsetHeight
                    let offsetBot = offsetTop + height

                    tab.offsetBot = offsetBot - 1
                    tab.offsetTop = offsetTop
                }
            })
        },
        loadCustomCss(attributes) {
            if (this.$route.query.preview === undefined && attributes !== null) {
                this.setFontFamily(this.aspect === null ? attributes.font_family : attributes.casp_font_family)
                this.setPrimaryColor(this.aspect === null ?
                  attributes.primary_color : attributes.casp_primary_color)
                this.setTitlesColor(this.aspect === null ? attributes.title_color : attributes.casp_title_color)
                this.setBackGroundColor(this.aspect === null ?
                  attributes.background_color : attributes.casp_background_color)
                this.setFieldsColor(this.aspect === null ? attributes.field_color : attributes.casp_field_color)
            }
        },
    },
    computed: {
        ...mapGetters('web_form', ['getFamilyByCode']),
        ...mapState('web_form', ['extra', 'contact', 'submitted', 'capacities', 'fields',
            'roomRenting', 'suggestedMedias', 'suggestedCommunications', 'categoryFamilies', 'isDirty']),
        ...mapState('preview', ['categoryFields', 'previewTxtIntro', 'previewEditedTabulations']),
        ...mapState('resource', ['categories']),
        ...mapState('webFormStyle', ['fontFamily', 'primaryColor', 'titlesColor', 'fieldsColor', 'backGroundColor'])
    },
    async created() {
        this.categoryCode = this.$route.query.category

        if(this.$route.query.aspect !== undefined) {
            this.aspect = this.$route.query.aspect
        }

        this.setPreview(true)
        this.setSourcesLoaded(true)

        this.$store.dispatch('resource/fetchLanguages')
        this.$store.dispatch('resource/fetchProfessions')
        this.$store.dispatch('resource/fetchCurrencies')
        this.$store.dispatch('resource/fetchCategories')
        await this.$store.dispatch('resource/fetchCommunicationTypes')

        this.getPreviewData()
    },
}
</script>